import React, { useState } from "react";
import PropTypes from "prop-types";

import { K_COLORS_DARK_NAVY } from "constants.js";

const LineWrap = (props) => {
  const { children } = props;
  const [isHovered, setIsHovered] = useState(false);

  const lineStyle = {
    width: isHovered ? "30%" : "15%",
  };

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={styles.container}
    >
      <div style={{ ...lineStyle, ...styles.line, ...styles.lineLeft }} />
      {children}
      <div style={{ ...lineStyle, ...styles.line, ...styles.lineRight }} />
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    margin: "5px",
  },
  line: {
    background: K_COLORS_DARK_NAVY,
    minWidth: "5rem",
    height: "0.1rem",
    display: "flex",
    transition: "all 0.5s",
  },
  lineLeft: {
    alignItems: "flex-end",
    marginRight: "0.25rem",
    backgroundColor: K_COLORS_DARK_NAVY,
  },
  lineRight: {
    alignItems: "flex-start",
    marginLeft: "0.25rem",
    backgroundColor: K_COLORS_DARK_NAVY,
  },
};

LineWrap.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

export default LineWrap;
